<template>
    <div class="wrapper ecommerce-page">
        <div class="main">
            <page-header/>
            <div class="section">
                <div class="container">
                    <div class="row">
                        <div class="col-md-3">
                            <div class="collapse-panel">
                                <div class="card-body">
                                    <div class="card card-refine card-plain">
                                        <div>
                                            <fg-input
                                                    class="search_input"
                                                    placeholder="搜尋商品"
                                                    addon-right-icon="now-ui-icons ui-1_zoom-bold"
                                                    v-model="search"
                                                    @input="handleChangeSearch"
                                            ></fg-input>
                                        </div>
                                        <div>
                                            <el-select
                                                    v-model="searchCategory"
                                                    placeholder="商品類別"
                                                    class="select-info"
                                                    @change="handleChangeCategory"
                                            >
                                                <el-option
                                                        v-for="item in categoryOptions"
                                                        :key="item.category_id"
                                                        :label="item.name"
                                                        :value="item.category_id"
                                                ></el-option>
                                            </el-select>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="col-md-9">
                            <div class="row">
                                <div
                                        class="col-lg-4 col-md-6"
                                        v-for="p in product"
                                        :key="p.product_id"
                                        @click="goProductDetail(p)"
                                >
                                    <card type="product" plain>
                                        <img class="product-list-image" slot="image" :src="p.cover_image ? p.cover_image.path : ''" alt/>

                                        <a href="#">
                                            <h4 class="card-title">{{ p.name }}</h4>
                                        </a>
                                        <div class="card-footer">
                                            <div v-if="p.plans && p.plans.length > 0" class="d-flex flex-row justify-content-center">
                                                <span class="price">最低月付金額</span>
                                                <span class="price money">＄{{  p.plans[p.plans.length - 1].period_amount }}</span>
                                            </div>
                                        </div>
                                    </card>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <infinite-loading @infinite="loadMore" :identifier="loadingIdentifier">
            <div slot="no-more">沒有更多商品囉</div>
            <div slot="no-results">沒有更多商品囉</div>
        </infinite-loading>
    </div>
</template>
<script>
    import {
        Card,
        Button,
        InfoSection,
        FormGroupInput,
        Checkbox,
        Collapse,
        CollapseItem,
        Slider
    } from "@/components";
    import _ from 'lodash';
    import {PRODUCT_QUERY} from "@/services/graphql/product";
    import {CATEGORY_QUERY} from "@/services/graphql/category"
    import {Carousel, CarouselItem, Tooltip, Select, Option} from "element-ui";
    import InfiniteLoading from "vue-infinite-loading";
    import Vue from "vue";
    import PageHeader from "@/views/partials/PageHeader";

    Vue.use(InfiniteLoading, {
        props: {
            distance: 800
        },
        system: {
            throttleLimit: 100
        }
    });

    export default {
        name: "product-list",
        bodyClass: "ecommerce-page",
        components: {
            PageHeader,
            Card,
            InfoSection,
            Collapse,
            CollapseItem,
            Slider,
            InfiniteLoading,
            [Button.name]: Button,
            [Checkbox.name]: Checkbox,
            [FormGroupInput.name]: FormGroupInput,
            [Carousel.name]: Carousel,
            [CarouselItem.name]: CarouselItem,
            [Tooltip.name]: Tooltip,
            [Option.name]: Option,
            [Select.name]: Select
        },
        apollo: {
            category: {
                query: CATEGORY_QUERY
            },
        },
        computed: {
            categoryOptions() {
                const option = _.cloneDeep(this.category);

                option.unshift({
                    category_id: null,
                    name: '選擇分類',
                });

                return option;
            },
            loadingIdentifier() {
                return `${this.search}-${this.searchCategory}-`;
            }
        },
        data() {
            return {
                first: 6,
                currentPage: 1,
                category: [],
                product: [],
                searchCategory: null,
                busy: false,
                search: ""
            };
        },
        methods: {
            goProductDetail(item) {
                this.$router.push({
                    name: "ProductDetail",
                    params: {
                        product_id: item.product_id
                    },
                    query: this.$route.query
                });
            },
            async loadMore($state) {
                try {
                    const q = await this.$apollo.query({
                        query: PRODUCT_QUERY,
                        variables: {
                            first: this.first,
                            page: this.currentPage,
                            name: this.search,
                            category_id: this.searchCategory
                        },
                        fetchPolicy: "network-only"
                    });

                    this.product.push(...q.data.product.data);
                    this.currentPage += 1;
                    if (q.data.product.data.length === 0) $state.complete();
                    else $state.loaded();
                } catch (err) {
                    console.error(err);
                    $state.complete();
                }
            },
            check() {
                console.log("product", this.product);
                console.log("offset", this.offset);
            },
            resetProduct() {
                this.currentPage = 1;
                this.product = [];
            },
            handleChangeSearch() {
                this.resetProduct();
            },
            handleChangeCategory() {
                this.resetProduct();
            },
        }
    };
</script>
<style lang="scss" scoped>
    .search_input {
        margin: 0 0 10px 0;
    }

    h6 {
        font-size: 1.1em;
    }

    img {
        height: 20vh;
    }

    .product-list-image {
        display: block;
        margin: 0 auto;
    }

    .money {
        color: red !important;
    }

    @media screen and (max-width: 600px) {
        .section {
            padding: 0 0 0 0;
        }
        h6 {
            font-size: 1em;
        }
        img {
            height: 30vh;
        }
        .price {
            text-align: center;
        }
    }
</style>
